var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedEthw0)",
    d: "M12 9.926L6.857 12L12 3.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedEthw1)",
    d: "M12 9.926L17.143 12L12 3.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedEthw2)",
    d: "m12 14.572l-5.143-2.71L12 9.858z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCF7",
    d: "m12.005 14.572l5.138-2.71l-5.138-2.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0B4E9",
    d: "m14.713 8.524l-.27 4.77l-2.503-3.257l-2.485 3.373l-.292-4.616l.124-.004l.266 4.269l2.383-3.228l2.4 3.12l.253-4.435l.128.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedEthw3)",
    d: "M9.24 9.004a.64.64 0 0 0 .647-.63c0-.348-.29-.63-.647-.63a.64.64 0 0 0-.647.63c0 .348.29.63.647.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADCF4",
    d: "M9.386 7.89c.051-.034.163.017.214.047c.013.047.035.146-.025.172c-.073.03-.065-.052-.138-.078c-.072-.03-.124-.094-.055-.141z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedEthw4)",
    d: "M12.005 10.509a.64.64 0 0 0 .647-.63c0-.348-.29-.63-.647-.63a.64.64 0 0 0-.648.63c0 .348.29.63.648.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADCF4",
    d: "M12.146 9.399c.056-.039.167.012.214.042c.017.052.035.15-.021.172c-.073.03-.064-.047-.137-.077c-.077-.026-.129-.09-.056-.137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedEthw5)",
    d: "M14.67 9.004a.64.64 0 0 0 .647-.63c0-.348-.29-.63-.647-.63a.64.64 0 0 0-.647.63c0 .348.29.63.647.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADCF4",
    d: "M14.812 7.89c.055-.034.167.017.214.047c.017.047.034.146-.021.172c-.073.03-.065-.052-.142-.078c-.073-.03-.12-.094-.051-.141"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedEthw6)",
    d: "M14.396 13.86a.64.64 0 0 0 .647-.63c0-.348-.29-.63-.647-.63a.64.64 0 0 0-.647.63c0 .348.29.63.647.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADCF4",
    d: "M14.537 12.746c.056-.035.168.017.215.047c.017.047.034.146-.022.171c-.073.03-.064-.051-.141-.077c-.073-.03-.12-.094-.052-.141"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedEthw7)",
    d: "M9.48 13.86a.64.64 0 0 0 .647-.63c0-.348-.29-.63-.647-.63a.64.64 0 0 0-.647.63c0 .348.29.63.647.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADCF4",
    d: "M9.622 12.746c.055-.035.171.017.214.047c.017.047.039.146-.021.171c-.073.03-.065-.051-.138-.077c-.072-.03-.124-.094-.055-.141"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedEthw8)",
    d: "m12.047 15.772l-5.142-2.915l5.142 7.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8CCF7",
    d: "m12 15.772l5.143-2.915L12 20.143z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedEthw0",
    x1: 7.037,
    x2: 15.395,
    y1: 17.349,
    y2: 7.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A795F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D0E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedEthw1",
    x1: 6.857,
    x2: 14.023,
    y1: 7.071,
    y2: 19.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DBF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedEthw2",
    x1: 17.006,
    x2: 7.783,
    y1: 6.596,
    y2: 8.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6CDFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedEthw3",
    x1: 16.564,
    x2: 6.587,
    y1: 7.125,
    y2: 13.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7890D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedEthw4",
    x1: 16.53,
    x2: 6.576,
    y1: 7.181,
    y2: 13.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7890D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedEthw5",
    x1: 16.53,
    x2: 6.553,
    y1: 7.125,
    y2: 13.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7890D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedEthw6",
    x1: 16.53,
    x2: 6.576,
    y1: 7.125,
    y2: 13.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7890D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedEthw7",
    x1: 16.564,
    x2: 6.61,
    y1: 7.125,
    y2: 13.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7890D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedEthw8",
    x1: 7.955,
    x2: 19.239,
    y1: 4.815,
    y2: 15.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E89D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#677FF0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthw);
export default __webpack_public_path__ + "static/media/ethw.5fc92338d914fd6be18089281597e7dc.svg";
export { ForwardRef as ReactComponent };